var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select',{attrs:{"options":[{label:'-- Kies een relatie --', value: null}].concat(_vm.items),"value":_vm.value,"text-field":"label","value-field":"value"},on:{"change":function($event){return _vm.$emit('input',$event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }